import styled from "styled-components";

export const Container = styled.button`
  align-items: center;
  background-color: #fa821f;
  color: #fff;
  display: flex;
  font-size: 20px;
  height: 100px;
  justify-content: center;
  max-width: 500px;
  width: 100%;
`;
